module.exports = {"en":{"password":"Password"},"vi":{"password":"Mật khẩu"}}